/**
 * GL212-2 (glasronde 0.9.212, Frank 28 oktober 2026): "In de lijst Artefacten staat QIS.docx twee keer."
 *
 * Gemeten op een kopie van de live db: het waren TWEE bestanden, uit twee gesprekken ("wat is  QIS"
 * om 00:08 zonder project, "wat is QIS" om 00:13 in project QIS), met een andere inhoud. NS-A2 bewaart
 * met opzet elk document ("niets gaat verloren"), dus weghalen is geen reparatie. De lijst toonde alleen
 * de naam, en dan lijken twee bestanden er een.
 *
 * Een naam die vaker in de lijst staat, krijgt eronder uit welk gesprek hij komt en wanneer. Een naam
 * die er een keer staat, blijft zoals hij was. PUUR, op de taal na.
 */
import { localeVan } from "./datum";

export function herkomstBijDubbel(artefacten, gesprekken, taal) {
  const telling = {};
  for (const a of artefacten || []) telling[a.name] = (telling[a.name] || 0) + 1;
  const titels = {};
  for (const g of gesprekken || []) titels[g.id] = g.title;
  const uit = {};
  for (const a of artefacten || []) {
    if (telling[a.name] < 2) continue;
    const moment = new Date(/Z$|[+-]\d\d:?\d\d$/.test(a.created_at || "") ? a.created_at : `${a.created_at}Z`);
    const wanneer = Number.isNaN(moment.getTime()) ? ""
      : moment.toLocaleString(localeVan(taal), { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
    uit[a.id] = [titels[a.conversation_id], wanneer].filter(Boolean).join(" · ");
  }
  return uit;
}
